import { render, staticRenderFns } from "./PhaseInfo.vue?vue&type=template&id=796532c7&scoped=true"
import script from "./PhaseInfo.vue?vue&type=script&lang=js"
export * from "./PhaseInfo.vue?vue&type=script&lang=js"
import style0 from "./PhaseInfo.vue?vue&type=style&index=0&id=796532c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796532c7",
  null
  
)

export default component.exports